<div id="myStore" class="template1">
    <modal #memberLevel >
        <modal-content>
            <div class = "modal-header" id = "member-level-header">
                    <div class="color-blue">{{'customer-service.MEMBER LEVEL HISTORY' |translate | translateKey}}</div>
                   
            </div>
            <div class="modal-body padding-top5">
                    <div *ngIf="review.memberDetail" class="distributorInfo">
                            <div>
                                <span class="header-font bold">{{review.memberDetail.firstName | titlecase}}
                                    {{review.memberDetail.lastName | titlecase}}
                                </span>
                            </div>
                            <div>
                                <a *ngIf="review.memberDetail?.fboId"><i class="fa fa-copy" [copyToClipboard]="review.memberDetail.fboId"></i></a>
                                <span>{{review.memberDetail.fboId |distributorIdFormat}} </span>
                                <span *ngIf="review.memberDetail.memberLevel"> | </span>
                                <span>{{review.memberDetail.memberLevel | titlecase}}</span>
                            </div>
                        </div>
            </div>
            <div class="level-display">
                <div>{{'customer-service.Working Level' |translate}}&nbsp;:&nbsp;</div>
                <div>
                    <span *ngIf="review.memberDetail && review.memberDetail.operatingCountry">{{review.memberDetail.memberLevel
| titlecase}}</span>
                    <span *ngIf="review.memberDetail && !review.memberDetail.operatingCountry">{{review.memberDetail.memberLevel
| titlecase}}</span>
                </div>
            </div>
            <div class="row mar-top-10">
                <div class="table-section">
                    <div class="col-sm-12">
                        <div class="table-height">
                            <table class="table table-striped custab">
                                <thead>
                                    <tr>
                                        <th class="headerWhite">
                                            <strong class="levelInfo">
                                                {{'levelInfo.Date' |translate}}
                                            </strong>
                                        </th>
                                        <th class="headerWhite">
                                            <strong class="levelInfo">
                                                {{'levelInfo.Type' |translate}}
                                            </strong>
                                        </th>
                                        <th class="headerWhite">
                                            <strong class="levelInfo">
                                                {{'levelInfo.Level' |translate}}
                                            </strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="review.dataAvailable">
                                    <tr *ngFor="let levelInfo of review.memberLeveldata">
                                        <td class>
                                            <label>{{levelInfo.date | date: 'dd-MMM-yyyy'}}</label>
                                        </td>
                                        <td>
                                            <label>{{levelInfo.memberType}}</label>
                                        </td>
                                        <td>
                                            <label>{{levelInfo.level}}</label>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!review.dataAvailable">
                                    <tr>
                                        <td>
                                            <label>{{'levelInfo.No Levels Found' |translate}}</label>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-right mar-top-20">
                            <button class="btn grey-button" tabindex="0" type="button" (click)="closePopup()">
                                {{'customer-service.CLOSE' |translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </modal-content>
    </modal>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/member-level-popup.component.html